import { RacingStore, PageMethodsComposite } from "../../../data/store";
export type extendedPageMethodsComposite = PageMethodsComposite & { getUniqueOddsClass: Function };
export class RacingCombinedViewData {
    public provider:extendedPageMethodsComposite;
    racingStore: RacingStore

    constructor(provider: extendedPageMethodsComposite, nextRacesCount: number, appNavigation: any) {
        this.provider = provider;
        this.racingStore = RacingStore.getInstance;
        this.racingStore.webMethods = {
            pageMethods: provider.pageMethods,
            racingPageMethods: provider.racingPageMethods
        };

        this.racingStore.nextRacesCount = nextRacesCount;
        this.racingStore.appNavigation = appNavigation;
    }

    setParams(regionId: number, branchId: number) {
        this.racingStore.setParams(regionId, branchId);
    }

    deactivate() {
        this.racingStore.clear();
    }
}